<nav class="subnav">
  <div class="prev">
    <a [routerLink]="['/programme', 'progress']"
      ><span class="icon-wrap"
        ><fa-icon [icon]="['fas', 'circle-arrow-left']"></fa-icon></span
    ></a>
  </div>
  <h2>Weekly Objectives</h2>
  <div class="next">
    <a [routerLink]="['/programme', 'weekly-reports']">
      <span class="icon-wrap"
        ><fa-icon [icon]="['fas', 'circle-arrow-right']"></fa-icon></span
    ></a>
  </div>
</nav>

<app-loading-spinner *ngIf="isLoading"></app-loading-spinner>
<ng-container *ngIf="!isLoading && userData">
  <nav class="weekly-objectives-nav mt-3">
    <div class="weekly-objectives-nav-prev"></div>
    <div class="weekly-objectives-nav-title">
      <h3>Week {{ currentWeekNumber }}</h3>
    </div>
    <div class="weekly-objectives-nav-next"></div>
  </nav>
  <div class="container-inner">
    <div class="card bg-light mt-3">
      <div class="card-body">
        <ul class="link-list link-list-tasks">
          <li>
            <a [routerLink]="['/activity', 'steps']">
              <span class="icon-wrap more-link"
                ><fa-icon [icon]="['fas', 'walking']"></fa-icon
              ></span>
              <span class="link-label"
                ><span class="link-list-header">Prep Steps</span>
                <ng-container *ngIf="allTargets">
                  Walk over
                  {{ allTargets[allTargets.length - 1].target | number }} steps
                  every day this week
                </ng-container>
              </span>
              <span class="icon-wrap more-link duo-primary-dark"
                ><fa-icon [icon]="['fad', 'circle-chevron-right']"></fa-icon
              ></span>
            </a>
          </li>
          <li>
            <a [routerLink]="['/activity', 'fit']">
              <span class="icon-wrap more-link"
                ><fa-icon [icon]="['fas', 'running']"></fa-icon
              ></span>
              <span class="link-label"
                ><span class="link-list-header">Prep Fit</span> Complete 150
                minutes in total of moderate intensity aerobic training
              </span>
              <!--span class="icon-wrap more-link"
                ><fa-icon [icon]="['fas', 'check']"></fa-icon
              ></span-->
              <span class="icon-wrap more-link duo-primary-dark"
              ><fa-icon [icon]="['fad', 'circle-chevron-right']"></fa-icon
            ></span>
            </a>
          </li>
          <li>
            <a [routerLink]="['/activity', 'move']">
              <span class="icon-wrap more-link"
                ><fa-icon [icon]="$any(['fac', 'lunge'])"></fa-icon
              ></span>
              <span class="link-label"
                ><span class="link-list-header">Prep Strong</span> Complete at
                least two Level {{ userData.move_level }} strength
                workouts</span
              >
              <span class="icon-wrap more-link duo-primary-dark"
                ><fa-icon [icon]="['fad', 'circle-chevron-right']"></fa-icon
              ></span>
            </a>
          </li>
          <li>
            <a [routerLink]="['/activity', 'breathe']">
              <span class="icon-wrap more-link"
                ><fa-icon [icon]="['fas', 'lungs']"></fa-icon
              ></span>
              <span class="link-label"
                ><span class="link-list-header">Breathe Well</span> Complete
                twice daily IMT sessions every day this week and aim to increase
                your load</span
              >
              <span class="icon-wrap more-link duo-primary-dark"
                ><fa-icon [icon]="['fad', 'circle-chevron-right']"></fa-icon
              ></span>
            </a>
          </li>
          <li>
            <a [routerLink]="['/modules', 'i-quit']">
              <span class="icon-wrap more-link"
                ><fa-icon [icon]="['far', 'smoking-ban']"></fa-icon
              ></span>
              <span class="link-label"
                ><span class="link-list-header">I-Quit</span>
                <ng-container
                  *ngIf="
                    smokingTotalsLastWeek &&
                    smokingTotalsLastWeek.totalCigarettes > 0
                  "
                  >Aim to decrease the amount of cigarettes you smoked compared
                  to last week ({{ smokingTotalsLastWeek.totalCigarettes }})
                </ng-container>
                <ng-container
                  *ngIf="
                    smokingTotalsLastWeek &&
                    smokingTotalsLastWeek.totalCigarettes == 0 &&
                    smokingTotalsLastWeek.daysEntered > 0
                  "
                  >Aim to maintain the amount of smoke free days you had last
                  week ({{ smokingTotalsLastWeek.smokeFreeDays }})
                </ng-container>

                <ng-container
                  *ngIf="
                    smokingTotalsLastWeek &&
                    smokingTotalsLastWeek.daysEntered == 0
                  "
                  >Aim to add your smoking entries this week
                </ng-container>
              </span>
              <span class="icon-wrap more-link duo-primary-dark"
                ><fa-icon [icon]="['fad', 'circle-chevron-right']"></fa-icon
              ></span>
            </a>
          </li>
          <li>
            <a [routerLink]="['/modules', 'drink-guide']">
              <span class="icon-wrap more-link"
                ><fa-icon [icon]="['fas', 'martini-glass']"></fa-icon
              ></span>
              <span class="link-label"
                ><span class="link-list-header">Drinking Guide</span> Aim to
                drink no more than 14 units of alcohol this week
              </span>
              <span class="icon-wrap more-link duo-primary-dark"
                ><fa-icon [icon]="['fad', 'circle-chevron-right']"></fa-icon
              ></span>
            </a>
          </li>
          <li>
            <a [routerLink]="['/modules', 'feel-well']">
              <span class="icon-wrap more-link"
                ><fa-icon [icon]="['far', 'face-smile-relaxed']"></fa-icon
              ></span>
              <span class="link-label"
                ><span class="link-list-header">Feel Well</span> Enter your feel
                well entries this week
              </span>
              <span class="icon-wrap more-link duo-primary-dark"
                ><fa-icon [icon]="['fad', 'circle-chevron-right']"></fa-icon
              ></span>
            </a>
          </li>
          <li>
            <a [routerLink]="['/modules', 'sleep-well']">
              <span class="icon-wrap more-link"
                ><fa-icon [icon]="['far', 'face-sleeping']"></fa-icon
              ></span>
              <span class="link-label"
                ><span class="link-list-header">Sleep Well</span>

                Enter your sleep well entries this week
              </span>
              <span class="icon-wrap more-link duo-primary-dark"
                ><fa-icon [icon]="['fad', 'circle-chevron-right']"></fa-icon
              ></span>
            </a>
          </li>
          <li>
            <a [routerLink]="['/modules', 'eat-well']">
              <span class="icon-wrap more-link"
                ><fa-icon [icon]="['fas', 'cutlery']"></fa-icon
              ></span>
              <span class="link-label"
                ><span class="link-list-header">Eat Well</span> Enter your eat
                well entries this week
              </span>
              <span class="icon-wrap more-link duo-primary-dark"
                ><fa-icon [icon]="['fad', 'circle-chevron-right']"></fa-icon
              ></span>
            </a>
          </li>
        </ul>

        <!--div class="stat p-2">
        <div class="progress bg-light mb-1">
          <div
            class="progress-bar bg-primary"
            role="progressbar"
            style="width: 25%"
            aria-valuenow="25"
            aria-valuemin="0"
            aria-valuemax="100"
          ></div>
        </div>
        <div class="stat-title-subtext">
          <strong>1 of 8 Activity Tasks</strong> completed
        </div>
      </div-->
      </div>
    </div>
  </div>
</ng-container>
